import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ShoppingInStoreRoutingModule} from './shopping-in-store.routing.module';
import {ShoppingInStoreComponent} from './shopping-in-store.component';
import {QRCodeModule} from 'angular2-qrcode';
import {CheckoutModule} from '../checkout/checkout.module';
import {MaterialModule} from '../material.module';
import {SharedComponentsModule} from '../shared-components/shared-components.module';
import {ShoppingInStoreResolverService} from './shopping-in-store.resolver';
import {ProfileModule} from '../profile/profile.module';


@NgModule({
    declarations: [
        ShoppingInStoreComponent
    ],
    imports: [
        QRCodeModule,
        ShoppingInStoreRoutingModule,
        CommonModule,
        CheckoutModule,
        MaterialModule,
        SharedComponentsModule,
        ProfileModule,
    ],
    providers: [
        ShoppingInStoreResolverService
    ]
})
export class ShoppingInStoreModule {
}
